import { useAppDispatch, useAppSelector } from '@/shared/infra/store/hooks';
import { setStates } from './stateSlice';
import EmployerState from '../../features/employer-selection/application/domain/entities/employerState';

export const useReduxStatesAdapter = () => {
  const dispatch = useAppDispatch();
  const { states } = useAppSelector((state) => state.states);

  return {
    getStates: () => {
      return states;
    },
    setStates: async (states: Array<EmployerState>) => {
      dispatch(setStates(states));
    },
  };
};
